import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import UserGroupsUsersTab from  '@/components/page/OrgSettings/UserGroups/UserGroupsUsersTab';

//context
import { OrgSettingsUserGroupsContext } from '@/context/OrgSettingsUserGroupsContext';



const UserGroupsUserTabPortal = () => {    
    const { setUserGroupId, setGroupCanBeModified, setUserGroupName} = useContext(OrgSettingsUserGroupsContext);

    const targetContainer = document.getElementById('react-group-users-tab-container');
    if (!targetContainer) {
        return null;
    } else {
        setUserGroupId(targetContainer?.getAttribute('data-user-group-id') ?? "")
        setGroupCanBeModified((targetContainer.getAttribute('data-group-can-be-modified') === 'True') && (targetContainer.getAttribute('data-is-managed-group') !== "True"));
        setUserGroupName(targetContainer?.getAttribute('data-user-group-name') ?? "")
    }

    return ReactDOM.createPortal(
      <UserGroupsUsersTab
          isExternalGroup={targetContainer.getAttribute('data-is-managed-group') === "True"}
      />, targetContainer
    );
}


export default UserGroupsUserTabPortal;